/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import { createTheme } from "@mui/material/styles";

const bodyFont = "var(--zamp-font-body)";
const headlineFont = "var(--zamp-font-headline)";

const headlineStyle = {
    fontFamily: headlineFont,
    letterSpacing: "var(--zamp-tracking-headline)",
    lineHeight: "var(--zamp-leading-headline)",
};

const bodyStyle = {
    fontFamily: bodyFont,
    letterSpacing: "var(--zamp-tracking-body)",
    lineHeight: "var(--zamp-leading-body)",
};

const buttonStyle = {
    fontFamily: bodyFont,
    letterSpacing: "var(--zamp-tracking-button)",
    lineHeight: "var(--zamp-leading-button)",
};

const zampTheme = createTheme({
    typography: {
        fontFamily: bodyFont,
        h1: headlineStyle,
        h2: headlineStyle,
        h3: headlineStyle,
        h4: headlineStyle,
        h5: headlineStyle,
        h6: headlineStyle,
        subtitle1: headlineStyle,
        subtitle2: bodyStyle,
        body1: bodyStyle,
        body2: bodyStyle,
        button: buttonStyle,
        caption: bodyStyle,
        overline: bodyStyle,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: bodyStyle,
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: headlineStyle,
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: bodyStyle,
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: bodyStyle,
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: bodyStyle,
                input: bodyStyle,
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: bodyStyle,
                input: bodyStyle,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: buttonStyle,
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: bodyStyle,
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: bodyStyle,
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: bodyStyle,
            },
        },
        MuiPickersCalendarHeader: {
            styleOverrides: {
                label: bodyStyle,
            },
        },
    },
});

export default zampTheme;
